import { Link } from 'react-router-dom';
import SectionHeader from '@/components/feature/SectionHeader';
import { ArmedGroup, ArmedReveal } from '@/lib/motion/Reveal';
import { playRouteFade } from '@/lib/route-fade';

const studioImage = {
  src: 'https://readdy.ai/api/search-image?query=Observational%20editorial%20photograph%20of%20a%20bright%20daylight%20photography%20studio%20with%20tall%20industrial%20windows%2C%20large%20white%20diffusion%20panels%20and%20softboxes%20on%20light%20stands%2C%20seamless%20paper%20backdrop%2C%20camera%20on%20tripod%2C%20styling%20table%20with%20fabrics%2C%20two%20crew%20members%20working%20naturally%20not%20looking%20at%20camera%2C%20calm%20premium%20atmosphere%2C%20natural%20colours&width=1920&height=1080&seq=mv-studio-fullbleed&orientation=landscape',
  alt: 'Daylight photography studio with softboxes, backdrop and crew at work',
};

export default function AboutSection() {
  return (
    <section id="studio" aria-labelledby="studio-title" className="relative scroll-mt-16">
      <ArmedGroup kind="media" mediaScale={1.07} mediaDur={1.15} className="relative h-[520px] w-full overflow-hidden md:h-[72vh] md:min-h-[560px]">
        <img
          src={studioImage.src}
          alt={studioImage.alt}
          title="Maren Voss Photography — studio in Berlin"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/50 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 px-4 pb-10 md:px-10 md:pb-14">
          <div className="mx-auto max-w-[1200px]">
            <SectionHeader
              index="03"
              name="Studio"
              tone="inverse"
              titleId="studio-title"
              title={<>Photography shaped by<br className="hidden md:block" /> people, light and collaboration.</>}
              className="!mb-0"
            />
            <ArmedReveal variant="support" delay={280}>
              <Link to="/studio" onClick={playRouteFade} className="mo-btn mo-btn--cta mt-8 inline-flex items-center gap-2 border-b border-white/70 pb-1 font-label text-[11px] font-medium uppercase tracking-[0.12em] text-white hover:opacity-70 whitespace-nowrap cursor-pointer">
                Visit the studio <span aria-hidden="true" className="mo-arrow">→</span>
              </Link>
            </ArmedReveal>
          </div>
        </div>
      </ArmedGroup>
    </section>
  );
}